module.exports = __webpack_public_path__ + "static/media/page-12.8b427473.png";